module.exports = __webpack_public_path__ + "img/68bdc86ccc004c2e8a4c80f38909e4f4-1440.d0735f63.jpg";